import script from "./HomeVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeVideo.vue?vue&type=script&setup=true&lang=js"

import "./HomeVideo.vue?vue&type=style&index=0&id=b0d50f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d50f9e"]])

export default __exports__